import React, { useState } from 'react';
import clsx from 'clsx';
import FAQ from './faq';
import { BaseComponentProps } from '@utils/types/baseComponents';
import styles from './styles.module.scss';

type Props = {
  faqs: {
    question: string;
    answerRaw: any;
  }[];
} & BaseComponentProps;

const FAQs = (props: Props) => {
  const { faqs, containerStyle } = props;
  const [selectedFAQs, setSelectedFAQs] = useState<number[]>([0]);

  const onFAQClick = (index: number) => {
    if (selectedFAQs.includes(index)) {
      setSelectedFAQs(selectedFAQs.filter((i) => i !== index));
    } else {
      setSelectedFAQs([...selectedFAQs, index]);
    }
  };

  return (
    <div className={clsx([styles.faqs, containerStyle])}>
      {faqs.map((f, index) => (
        <FAQ
          {...f}
          key={index}
          index={index}
          isSelected={selectedFAQs.includes(index)}
          onClick={onFAQClick}
        />
      ))}
    </div>
  );
};

export default FAQs;
